import React, { useEffect } from "react";
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import RoutesContainer from "./routes";
import { showToast } from "services/helper";

function AppRouter() {
  return (
    <BrowserRouter>
      <OnRouteChange />
      <RoutesContainer />
    </BrowserRouter>
  );
}

export default AppRouter;

function OnRouteChange() {
  const userIsLogged = useSelector((state) => state?.user?.token)?.length > 0;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname } = { ...location };
    const userMustSignIn =
      !userIsLogged &&
      pathname !== "/login" &&
      pathname !== "/recovery-password";
    if (userMustSignIn) {
      showToast(
        "Para ver essa página, primeiro entre com suas credenciais.",
        "error"
      );
      navigate("/login");
    }
  }, [location?.pathname]);

  return null;
}
